import axios from "axios";

//const
const EQUIPMENT_EDIT_UPDATE_DATA = "equipmentEdit/EQUIPMENT_EDIT_UPDATE_DATA";
const EQUIPMENT_EDIT_STORE_EQUIPMENT_CERTIFIES = "equipmentEdit/EQUIPMENT_EDIT_STORE_EQUIPMENT_CERTIFIES";
const EQUIPMENT_EDIT_STORE_EQUIPMENT_TYPES = "equipmentEdit/EQUIPMENT_EDIT_STORE_EQUIPMENT_TYPES";
const EQUIPMENT_EDIT_STORE_EQUIPMENT_STATUSES = "equipmentEdit/EQUIPMENT_EDIT_STORE_EQUIPMENT_STATUSES";
const EQUIPMENT_EDIT_STORE_EQUIPMENT = "equipmentEdit/EQUIPMENT_EDIT_STORE_EQUIPMENT ";
const EQUIPMENT_EDIT_TOGGLE_LOADING = "equipmentEdit/EQUIPMENT_EDIT_TOGGLE_LOADING";

//reducer
export const equipmentEdit = (state = {
  loading: false,

  equipmentCertifies: [],
  equipmentTypes: [],
  equipmentStatuses: [],

  equipment: {
    id: "",
    equipmentId: "",
    equipmentType: {id: ""},
    equipmentCertify: {id: ""},
    equipmentStatus: {id: ""},
    equipmentAddressable: false,
    equipmentIp: "",
    equipmentPort: "",
    collectNodeTags: [],
  },
  collectNodeTags: [],

  importTags: [],
  rowKey: 1,

}, action) => {
  switch (action.type) {
    case EQUIPMENT_EDIT_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case EQUIPMENT_EDIT_STORE_EQUIPMENT_CERTIFIES:
      return {
        ...state,
        equipmentCertifies: action.data,
      };
    case EQUIPMENT_EDIT_STORE_EQUIPMENT_TYPES:
      return {
        ...state,
        equipmentTypes: action.data,
      };
    case EQUIPMENT_EDIT_STORE_EQUIPMENT_STATUSES:
      return {
        ...state,
        equipmentStatuses: action.data,
      };
    case EQUIPMENT_EDIT_STORE_EQUIPMENT: {
      const collectNodeTags = action.data.collectNodeTags.map(node => {
        return {
          key: node.id,
          tag: node.tag,
          description: node.description,
          dataType: node.dataType,
          dataUnit: node.dataUnit
        }
      });
      return {
        ...state,
        equipment: action.data,
        collectNodeTags: collectNodeTags,
        importTags: [],
        rowKey: 1,
      };
    }
    case EQUIPMENT_EDIT_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based
 */
export const updateEquipmentData = (data) => {
  return {
    type: EQUIPMENT_EDIT_UPDATE_DATA,
    data: data
  }
};

/**
 * get equipment certifies
 */
export const getEquipmentCertifies = (enterpriseId) => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-equipment/getEquipmentCertifyListByEnterpriseId/${enterpriseId}`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeEquipmentCertifies(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all equipment certifies
 */
export const storeEquipmentCertifies = (equipmentCertifies) => {
  return {
    type: EQUIPMENT_EDIT_STORE_EQUIPMENT_CERTIFIES,
    data: equipmentCertifies
  }
};

/**
 * get equipment types
 */
export const getEquipmentTypes = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-equipment/getEquipmentTypeList`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeEquipmentType(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all equipment types
 */
export const storeEquipmentType = (equipmentTypes) => {
  return {
    type: EQUIPMENT_EDIT_STORE_EQUIPMENT_TYPES,
    data: equipmentTypes
  }
};

/**
 * get equipment statuses
 */
export const getEquipmentStatuses = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get(`/api-equipment/getEquipmentStatuses`, {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeEquipmentStatuses(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all equipment statuses
 */
export const storeEquipmentStatuses = (equipmentStatuses) => {
  return {
    type: EQUIPMENT_EDIT_STORE_EQUIPMENT_STATUSES,
    data: equipmentStatuses
  }
};
/**
 * check equipment
 */
export const initEquipmentEdit = (data) => (dispatch) => {
  let equipmentId = data.equipmentId;
  if (equipmentId !== null && equipmentId !== undefined && equipmentId !== "") {
    dispatch(toggleLoading(true));
    axios.get(`/api-equipment/getEquipmentById/${equipmentId}`, {contentType: "application/json"}).then(
      response => {
        if (response.data) {
          dispatch(storeEquipment(response.data));
          dispatch(toggleLoading(false));
        } else {
          dispatch(toggleLoading(false));
          this.props.history.push("/exception/415");
        }
      }
    );
  } else {
    dispatch(toggleLoading(false));
    this.props.history.push("/exception/415");
  }
};

/**
 * store equipment
 */
export const storeEquipment = (equipment) => {
  return {
    type: EQUIPMENT_EDIT_STORE_EQUIPMENT,
    data: equipment
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: EQUIPMENT_EDIT_TOGGLE_LOADING,
    data: show
  }
};
